export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20modern%20home%20theater%20setup%20with%20a%20large%20screen%20displaying%20soft%20colorful%20abstract%20visuals%2C%20cozy%20beige%20sofa%20with%20blankets%20and%20pillows%2C%20warm%20ambient%20lighting%20from%20string%20lights%2C%20cinematic%20atmosphere%2C%20editorial%20interior%20photography%2C%20terracotta%20and%20cream%20tones%2C%20minimalist%20aesthetic%2C%20intimate%20mood&width=800&height=600&seq=about-cinema-2026&orientation=landscape"
                alt="情侣影院的温馨观影空间"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium mb-4">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-5">
              情侣影院 — 为爱追剧而生
            </h2>
            <div className="space-y-4 text-foreground-500 text-sm leading-relaxed">
              <p>
                情侣影院创立于对美好追剧体验的追求。我们发现在忙碌的生活中，情侣之间最温馨的时光往往就是窝在一起看一部好剧——所以决定打造一个专注情侣观影的电视剧平台。
              </p>
              <p>
                我们精心收录国产剧全集和韩剧全集，覆盖甜宠、都市、古装、悬疑等多元类型。团队每日追踪各大平台的热播新剧，确保最新电视剧第一时间上线。所有剧集均支持高清在线观看，全免费无需注册。
              </p>
              <p>
                情侣影院不只是一个片库，更是情侣专属的追剧社区。我们根据情侣的观影习惯智能推荐内容，让每一对情侣都能在这里找到属于两个人的好剧。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500"></i>
                <span>2000+ 部电视剧</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500"></i>
                <span>每日同步更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500"></i>
                <span>永久免费高清</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}